import { Injectable } from '@angular/core';
// import { Http, Headers, RequestOptions } from '@angular/http';
import { SessionSetting, AppHttp } from '../../app.service';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class LoginService {

    // options = new RequestOptions({ headers: new Headers({ 'Content-Type': 'application/json' }) });

    constructor(private http: AppHttp) { }

    // private request(ps: any, act: string) {
    //     return this.http
    //         .post(`api/${act}`, ps, this.options)
    //         .toPromise()
    //         .then(r => r.json());
    // }

    public login(ps: any) {
        return this.http.post('main', '/main/login/login', ps);
    }

    // CAPCHA ID を取得する
    public requestCaptha() {
        return this.http.post('main', '/main/cpatcha/id', {});
    }

}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/login/login.service.ts